import React from 'react'

import { selectCurrentUserEmailIntegration } from '../../store/emailHub/emailUsers'
import { useAppSelector } from '../../store/hooks'

import { IntegrationEmailThread } from '../../models/Email'
import { User } from '../../models/User'

import { ContactEmailsInitialization } from './Initialization/EmailHubInitialization'
import { EmailTable } from './Table/EmailTable'
import { EmailFilters } from '../../components/EmailFilters/EmailFilters'

export interface ContactEmailsProps {
  contact: User
}

export const ContactEmailsV2: React.FC<ContactEmailsProps> = ({ contact }) => {
  return (
    <>
      <ContactEmailsInitialization contact={contact} />
      <>
        <ContactEmailsContent />
      </>
    </>
  )
}

const ContactEmailsContent = () => {
  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)

  const handleRowClicked = (thread: IntegrationEmailThread) => {
    window.open(`/dashboard/email/inbox/threads/${thread.externalId}`, '_blank', 'noopener noreferrer')
  }

  if (!emailIntegration) {
    return null
  }

  return (
    <div className='d-flex flex-column zocks-gap-2.5'>
      <EmailFilters withoutQuickFilter={true} withoutContactFilter={true} />
      <EmailTable onRowClicked={handleRowClicked} />
    </div>
  )
}
